import styled from 'styled-components';
import { sizes } from 'theme';

export const NotifierSlimContainer = styled.div`
    display: flex;
    align-items: center;
    gap: ${sizes.spacingSm};
`;
